import { NowImporting } from "@/components/molecules/NowImporting/NowImporting";
import type { ClubImportSubsection } from "@/events/clubImportMixpanel";

export type ClubImportOverlayData = {
  /** The screen the import was started from, for the Done event. */
  subsection?: ClubImportSubsection;
};

/**
 * The import-in-progress overlay, owned by ModalControllerV2.
 *
 * It used to be local state in whichever component happened to own an import
 * button, which is why only those components could start an import — every
 * other CTA had to route the user to one of them first. Raising it through the
 * modal slot means `useStartClubImport` can launch from anywhere.
 *
 * Full-screen rather than a dialog on purpose: the import is a job the user is
 * in the middle of, across two tabs, and a takeover says that where a panel
 * reads as an aside.
 *
 * NowImporting owns what Done and Cancel actually do (see useFinishImport), so
 * all that is left here is closing the modal slot.
 */
export const ClubImportOverlay = ({
  data,
  onClose,
}: {
  data?: ClubImportOverlayData;
  onClose: () => void;
}) => (
  <NowImporting
    onClickDone={onClose}
    onClickCancel={onClose}
    subsection={data?.subsection}
  />
);
